// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsFileXlsSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 5a3 3 0 0 1 3-3h7.172a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 20 7.828V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm9 3.5a.5.5 0 0 0 .5.5h3.293a.5.5 0 0 0 .353-.854l-3.292-3.292a.5.5 0 0 0-.854.353zm2.587 3.11c-.798 0-1.345.54-1.345 1.333 0 .352.105.615.315.788.142.116.31.19.752.32.483.143.62.242.62.458 0 .23-.2.383-.5.383-.304 0-.588-.126-.908-.404l-.442.83c.42.294.904.446 1.371.446.457 0 .862-.131 1.146-.373.267-.231.404-.578.404-1.024 0-.588-.284-.909-.972-1.114-.462-.136-.504-.152-.62-.247a.268.268 0 0 1-.094-.2c0-.193.189-.34.441-.34.236 0 .447.083.678.267l.41-.803c-.4-.205-.841-.32-1.256-.32zm-8.309.094 1.272 1.849L7 15.664h1.24l.893-1.287.84 1.287h1.245l-1.492-2.111 1.287-1.85H9.747l-.61 1.03-.587-1.03zm5.278 3.088v-3.088h-1.03v3.96h2.264v-.872z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsFileXlsSolid;
